import React from 'react';
import { TableRow, TableCell } from 'semantic-ui-react';
import { useSelector } from 'react-redux';

import { FertilizerProductId } from 'services/fertilizerProducts/types';
import StatusIcon from 'components/StatusIcon';
import { UPLOAD_FAILED } from 'components/StatusIcon/constants';
import { AppState } from 'services/types';
import {
    makeSelectFertilizerProductNPKValue,
    makeSelectFertilizerProductValue,
    makeSelectFertilizerProductSMgCaValue
} from 'services/fertilizerProducts/selectors';
import FertilizerEventProductsTableRowActions from '../FertilizerEventProductsTableRowActions';

interface Props {
    productId: FertilizerProductId;
    index?: number;
    handleRowClick: Function;
    invalid: boolean;
    handleOnDeleteRowClick: (
        event: React.MouseEvent<HTMLButtonElement>
    ) => void;
    handleOnSortingDownClick: (
        event: React.MouseEvent<HTMLButtonElement>
    ) => void;
    handleOnSortingUpClick: (
        event: React.MouseEvent<HTMLButtonElement>
    ) => void;
    displayActions?: boolean;
    displayErrors?: boolean;
}

export default function FertilizerEventProductsTableRow(
    props: Props
): React.ReactElement | null {
    const {
        productId,
        index,
        handleRowClick,
        invalid,
        handleOnDeleteRowClick,
        handleOnSortingUpClick,
        handleOnSortingDownClick,
        displayActions,
        displayErrors
    } = props;

    const fertilizerProductName = useSelector((state: AppState) =>
        makeSelectFertilizerProductValue('name')(state, { productId })
    );
    const fertilizerProductNPKValue = useSelector((state: AppState) =>
        makeSelectFertilizerProductNPKValue()(state, { productId })
    );
    const fertilizerProductSMgCaValue = useSelector((state: AppState) =>
        makeSelectFertilizerProductSMgCaValue()(state, { productId })
    );

    if (!index) return null;

    return (
        <TableRow onClick={handleRowClick} style={{ cursor: 'pointer' }}>
            <TableCell collapsing>{index}</TableCell>
            <TableCell textAlign="left">{fertilizerProductName}</TableCell>
            <TableCell>{fertilizerProductNPKValue}</TableCell>
            <TableCell>{productId && fertilizerProductSMgCaValue}</TableCell>
            <TableCell collapsing style={{ padding: 0 }}>
                {displayActions && (
                    <FertilizerEventProductsTableRowActions
                        handleOnSortingDownClick={handleOnSortingDownClick}
                        handleOnSortingUpClick={handleOnSortingUpClick}
                        handleOnDeleteClick={handleOnDeleteRowClick}
                    />
                )}
            </TableCell>
            {displayErrors && (
                <TableCell collapsing>
                    {invalid && <StatusIcon status={UPLOAD_FAILED} small />}
                </TableCell>
            )}
        </TableRow>
    );
}
